/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { MergedCardTransactionDetailEvidenceListInnerCreatedBy } from './merged-card-transaction-detail-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { MergedCardTransactionDetailEvidenceListInnerErrors } from './merged-card-transaction-detail-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer } from './merged-card-transaction-detail-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { MergedCardTransactionDetailEvidenceListInnerUpdatedBy } from './merged-card-transaction-detail-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { MergedCardTransactionDetailEvidenceListInnerUploadedBy } from './merged-card-transaction-detail-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { MergedCardTransactionDetailEvidenceListInnerWarnings } from './merged-card-transaction-detail-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface MergedCardTransactionDetailEvidenceListInner
 */
export interface MergedCardTransactionDetailEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'paymentType': MergedCardTransactionDetailEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'electronicMethod': MergedCardTransactionDetailEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'documentSize': MergedCardTransactionDetailEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'legalValidity': MergedCardTransactionDetailEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'invoiceIssuer': MergedCardTransactionDetailEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'dpiError': MergedCardTransactionDetailEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': MergedCardTransactionDetailEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': MergedCardTransactionDetailEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'colorGradationError': MergedCardTransactionDetailEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'heightMillisError': MergedCardTransactionDetailEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     * @deprecated
     */
    'widthMillisError': MergedCardTransactionDetailEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerErrors}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'errors': MergedCardTransactionDetailEvidenceListInnerErrors;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerWarnings}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'warnings': MergedCardTransactionDetailEvidenceListInnerWarnings;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerCreatedBy}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'createdBy': MergedCardTransactionDetailEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerUpdatedBy}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'updatedBy': MergedCardTransactionDetailEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {MergedCardTransactionDetailEvidenceListInnerUploadedBy}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'uploadedBy': MergedCardTransactionDetailEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInner
     */
    'uploadedFrom': string;
}

export const MergedCardTransactionDetailEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerPaymentTypeEnum = typeof MergedCardTransactionDetailEvidenceListInnerPaymentTypeEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerPaymentTypeEnum];
export const MergedCardTransactionDetailEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerElectronicMethodEnum = typeof MergedCardTransactionDetailEvidenceListInnerElectronicMethodEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerElectronicMethodEnum];
export const MergedCardTransactionDetailEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerDocumentSizeEnum = typeof MergedCardTransactionDetailEvidenceListInnerDocumentSizeEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerDocumentSizeEnum];
export const MergedCardTransactionDetailEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerLegalValidityEnum = typeof MergedCardTransactionDetailEvidenceListInnerLegalValidityEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerLegalValidityEnum];
export const MergedCardTransactionDetailEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerDpiErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerDpiErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerDpiErrorEnum];
export const MergedCardTransactionDetailEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerDetectedDpiErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerDetectedDpiErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerDetectedDpiErrorEnum];
export const MergedCardTransactionDetailEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerCalculatedDpiErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerCalculatedDpiErrorEnum];
export const MergedCardTransactionDetailEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerColorGradationErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerColorGradationErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerColorGradationErrorEnum];
export const MergedCardTransactionDetailEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerHeightMillisErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerHeightMillisErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerHeightMillisErrorEnum];
export const MergedCardTransactionDetailEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerWidthMillisErrorEnum = typeof MergedCardTransactionDetailEvidenceListInnerWidthMillisErrorEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerWidthMillisErrorEnum];


